<template>
  <v-container fluid fill-height>
      <div class="icons-left">
        <v-btn-toggle
          v-model="connTypes"
          multiple
          @change="applyEdgeFilter"
        >
          <v-btn rounded><v-icon>mdi-account-multiple</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-clock-outline</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-account-off-outline</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-alien-outline</v-icon></v-btn>
        </v-btn-toggle>
      </div>
      <div class="icons-right">
        <v-btn-toggle
          v-model="viewType"
          @change="changeView"
          class="ml-2"
        >
          <v-btn rounded><v-icon>mdi-medical-bag</v-icon></v-btn>
          <v-btn rounded><v-icon>mdi-account-group</v-icon></v-btn>
        </v-btn-toggle>
      </div>
      <network
        class="network fill-height"
        ref="network"
        :nodes="network.nodes"
        :edges="network.edges"
        :options="network.options"
      >
      </network>
      <div class="icons-bottom">
        <v-icon class="float-right align-end" large @click="fit">mdi-image-filter-center-focus</v-icon>
      </div>
  </v-container>
</template>
<script>
import { Network } from "vue2vis";

var groupsDots = {
    'ok': {color: 'green', title: 'ok'},
    'med': {color: 'orange'},
    'high': {color: 'red'}
};

export default {
  name: 'Graph',
  components: {
    Network
  },
  data: () => ({
    progress: false,
    graphData: null,
    allEdges: [],
    allNodes: [],
    connTypes: [0,1,2,3],
    viewType: 0,
    network: {
      nodes: [
        /*
        { id: 1, group: "ok" },
        { id: 2, group: "ok" },
        { id: 3, group: "med" },
        { id: 4, group: "high" },
        { id: 5, group: "med" }
        */
      ],
      edges: [
        /*
        { id: 1, from: 1, to: 3 },
        { id: 2, from: 1, to: 2 },
        { id: 3, from: 2, to: 4 },
        { id: 4, from: 2, to: 5 },
        { id: 5, from: 3, to: 3 }
        */
      ],
      options: {
        clickToUse: false,
        autoResize: false,
        groups: groupsDots,
        nodes: {
            shape: 'dot',
            size: 10,
            font: {
                color: 'white',
                size: 14,
                face: 'Arial'
            }
        },
        edges: {
            width: 1,
            /*color: {inherit: 'from'},*/
            smooth: {
                type: 'dynamic'
            },
            font: {
                size: 10
            }
        },
        physics: {
            enabled: true,
            stabilization:{
                enabled: true,
                iterations: 10
            },
            barnesHut:{
              gravitationalConstant: -12000,
              springConstant:0.02
            }
        },
        interaction: {
            tooltipDelay: 200,
            hideEdgesOnDrag: false
        }
      }
    }
  }),
  async mounted() {
    await this.$store.dispatch('loadGraph')
    this.allNodes = this.$store.state.graphData.nodes
    this.allEdges = this.$store.state.graphData.edges
    this.allNodes.forEach(node => {
      node.color = node.stateColor
      if (node.root) {
        node.size = 50
        node.title = 'mee'
        this.root = node.id
      }
    })
    this.changeView()
    this.applyEdgeFilter()
    var self = this
    setTimeout(function(){
      self.$refs.network.fit()
      self.$refs.network.focus(self.root)
    }, 500);
    //alert(JSON.stringify(this.$store.state.graphData))
  },
  methods: {
    fit() {
      this.$refs.network.fit()
      this.$refs.network.focus(this.root)
    },
    applyEdgeFilter() {
      var showPermanent = this.connTypes.includes(0)
      var showTransient = this.connTypes.includes(1)
      var showVirtual = this.connTypes.includes(2)
      var showForeign = this.connTypes.includes(3)
      var edges = []
      this.allEdges.forEach(edge => {
        if ((edge.type === 'P' && showPermanent) ||
          (edge.type === 'T' && showTransient) ||
          (edge.type === 'V' && showVirtual) ||
          (edge.type === 'F' && showForeign)
        ) {
            edges.push(edge)
          }
      })
      this.network.edges = edges
    },
    changeView() {
      var nodes = []
      if (this.viewType == 0) {
        this.allNodes.forEach(node => {
          var n = {}
          n.id = node.id
          n.color = node.color
          if (node.size) {
            n.size = node.size
          }
          nodes.push(n)
        })
        this.network.nodes = nodes
        this.$refs.network.setData(this.network.nodes, this.network.edges)
      } else {
        this.allNodes.forEach(node => {
          var group = (node.tribe ? node.tribe: 'meeconn')
          var n = {}
          n.id = node.id
          n.group = group
          n.title = group
          if (node.size) {
            n.size = node.size
          }
          nodes.push(n)
        })
        this.network.nodes = nodes
        this.$refs.network.setData(this.network.nodes, this.network.edges)
      }
    }
  }
}
</script>
<style lang="css">
@import "../../node_modules/vue2vis/dist/vue2vis.css";
.network {
  border: 0px solid blue;
  margin: 0px 0px;
  width: 100%;
}

.network canvas {
  width: 100%;
  height: 100%;
}

.icons-bottom {
  z-index: 9;
  bottom: 25px;
  right: 20px;
  position: absolute;
}
.icons-left {
  z-index: 9;
  top: 10px;
  left: 10px;
  position: absolute;
}
.icons-right {
  z-index: 9;
  top: 10px;
  right: 10px;
  position: absolute;
}
</style>
